/**
 * @fileoverview Componente responsável por controlar a renderização com base em permissões do usuário.
 */

import rules from "../../rules";
import usePermission from "../../hooks/usePermission";

const check = (role, action, data) => {
	const permissions = rules[role];
	if (!permissions) {
		// role is not present in the rules
		return false;
	}

	const staticPermissions = permissions.static;

	if (staticPermissions && staticPermissions.includes(action)) {
		// static rule not provided for action
		return true;
	}

	const dynamicPermissions = permissions.dynamic;

	if (dynamicPermissions) {
		const permissionCondition = dynamicPermissions[action];
		if (!permissionCondition) {
			// dynamic rule not provided for action
			return false;
		}

		return permissionCondition(data);
	}
	return false;
};

// Com "permission" (a do catálogo): ela, com a regra nova ligada na empresa;
// senão, a regra de hoje, a do rules.js ou a que vem em "legacy".
const Can = ({ role, perform, data, yes, no, permission, legacy }) => {
	const { can: canPermission } = usePermission();
	const before = legacy !== undefined ? !!legacy : check(role, perform, data);
	return (permission ? canPermission(permission, before) : before) ? yes() : no();
};

Can.defaultProps = {
	yes: () => null,
	no: () => null,
};

// A mesma regra fora do JSX (itens de menu montados em lista, rotas), para um
// usuário: o super passa, como no isAdmin da API.
const allows = (user, action, data) => !!user?.super || check(user?.profile, action, data);

export { Can, check as can, allows };
